export const messages = {
  es: {
    translations: {
      confirmationModal: {
        buttons: {
          cancel: "Cancelar",
          confirm: "Confirmar"
        },
        deleteTitle: "Eliminar",
        deleteMessage: "¿Seguro que deseas eliminar este registro? Esta acción no se puede deshacer.",
        disconnectTitle: "Desconectar",
        disconnectMessage: "¿Seguro que deseas desconectar?",
        importTitlte: "Importar contactos",
        importMessage: "¿Deseas importar todos los contactos de la agenda del teléfono?"
      },
      settings: {
        schedulesUpdated: "Horarios actualizados con éxito",
        company: {
          form: {
            name: "Nombre",
            email: "E-mail",
            phone: "Teléfono",
            plan: "Plan",
            status: "Estado",
            campanhas: "Campañas",
            enabled: "Habilitado",
            disabled: "Deshabilitado",
            dueDate: "Vencimiento",
            recurrence: "Recurrencia",
            monthly: "Mensual",
            yes: "Sí",
            no: "No",
            createdAt: "Creado",
            expire: "Vence",
            paidUsers: "Usuarios"
          },
          buttons: {
            clear: "Limpiar",
            delete: "Eliminar",
            expire: "Renovar",
            user: "Usuarios",
            save: "Guardar"
          },
          toasts: {
            success: "Cambios guardados",
            error: "No se pudo completar la operación",
            errorList: "No se pudieron cargar las compañías",
            errorOperation: "No se pudo completar la operación"
          },
          confirmModal: {
            title: "Eliminar compañía",
            message:
              "¿Seguro que deseas eliminar esta compañía? Esta acción no se puede deshacer."
          }
        }
      }
    }
  }
};
